import React from "react";


const BlurryBackground: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: -1,
      }}
    >
      <defs>
        <filter id="blurry" x="0%" y="0%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="110" />
        </filter>
      </defs>
      <g filter="url(#blurry)" style={{ width: "100%", height: "100%" }}>
        <circle cx="0" cy="0" r="116" fill="transparent" />
        <circle
          cx="-250px"
          cy="-600px"
          r="116"
          fill="var(--bs-success)"
          style={{ transform: "translate(50%, 50%)" }}
        />
        <circle
          cx="-700px"
          cy="-5%"
          r="152"
          fill="var(--bs-success)"
          style={{ transform: "translate(50%, 50%)" }}
        />
        <circle
          cx="-300"
          cy="570px"
          r="152"
          fill="var(--bs-primary)"
          style={{ transform: "translate(50%, 50%)" }}
        />
        <circle
          cx="730px"
          cy="0"
          r="145"
          fill="var(--bs-primary)"
          style={{ transform: "translate(50%, 50%)" }}
        />
      </g>
      <rect style={{ width: "200%", height: "200%" }} fill="rgb(255,255,255)" fillOpacity="0" />
    </svg>
  );
};

export default BlurryBackground;
